<template>
  <el-dialog
    :title="$t('receivablePayable.exportOrdersByDate')"
    :visible.sync="visible"
    width="500px"
    :before-close="close"
  >
    <el-form
      ref="form" :model="form" size="small"
      :rules="rules"
      label-position="top"
    >
      <el-form-item prop="date">
        <template slot="label">
          <el-select v-model="form.timeField" :placeholder="$t('operationCenter.PleaseSelect')">
            <!--业务时间-->
            <el-option :label="$t('basicData.BusinessTime')" value="operate_time" />
            <!-- 客户出仓时间 -->
            <el-option :label="$t('newOrder.clientExitTime')" value="customer_send_time" />
          </el-select>
        </template>
        <el-date-picker
          v-model="form.date"
          type="datetimerange"
          range-separator="-"
          :start-placeholder="$t('operationCenter.startDate')"
          :end-placeholder="$t('operationCenter.endDate')"
          style="width: 100%"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>
      <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
        <QueryCustomerCmp :val="form.customerId" @change="val => form.customerId = val" />
      </el-form-item>
      <!--      业务类型-->
      <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
        <el-select
          v-model="form.businessType"
          :placeholder="$t('operationCenter.PleaseSelect')"
          clearable
          style="width: 100%;"
          @change="changeType"
        >
          <!--揽收订单-->
          <el-option :label="$t('collectionCenter.lanshou')" :value="1" />
          <!--快递订单-->
          <el-option :label="$t('collectionCenter.expressDelivery')" :value="0" />
        </el-select>
      </el-form-item>
      <!--揽收类型-->
      <el-form-item v-if="form.businessType === 1" :label="$t('newOrder.CollectionType')" prop="collectionCategory">
        <el-select
          v-model="form.collectionCategory"
          :placeholder="$t('operationCenter.PleaseSelect')"
          clearable
          style="width: 100%;"
        >
          <!--全部-->
          <el-option
            v-for="item in COLLECTION_CATEGORY_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!--货物类型-->
      <el-form-item v-if="form.businessType === 0" :label="$t('placeOrder.cargoType')" prop="cargoType">
        <el-select
          v-model="form.cargoType"
          :placeholder="$t('operationCenter.PleaseSelect')"
          clearable
          style="width: 100%;"
        >
          <el-option
            v-for="(item, ind) in CARGO_TYPE"
            :key="ind"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item></el-form>

    <div slot="footer" class="dialog-footer">
      <el-alert
        :title="$t('receivablePayable.exportLimit')"
        type="warning"
        show-icon
        :closable="false"
      />
      <el-button size="small" @click="close">{{ $t('basicData.Cancel') }}</el-button>
      <el-button size="small" type="primary" @click="submit">{{ $t('basicData.determine') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { EXPRESS_TYPE } from '../../utils';
import { cloneDeep } from 'lodash-es';
import { apiExportDate } from '@/api/finance/receivables';
import { goFinanceExportPage } from '@/utils/goExportList';
import { CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';
import { COLLECTION_CATEGORY_TYPE } from '@/views/finance/enums';
export default {
  components: {
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp')
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      COLLECTION_CATEGORY_TYPE,
      CARGO_TYPE,
      EXPRESS_TYPE,
      form: {
        timeField: 'operate_time',
        date: [],
        customerId: '',
        businessType: '',
        collectionCategory: '',
        cargoType: ''
      },
      rules: {
        date: [
          { required: true, message: this.$t('operationCenter.PleaseSelect') }
        ],
        customerId: [
          { required: true, message: this.$t('operationCenter.PleaseSelect') }
        ],
        businessType: [
          { required: true, message: this.$t('operationCenter.PleaseSelect') }
        ],
        collectionCategory: [
          { required: true, message: this.$t('operationCenter.PleaseSelect') }
        ],
        cargoType: [
          { required: true, message: this.$t('operationCenter.PleaseSelect') }
        ]
      }
    };
  },

  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form);
          const params = cloneDeep(this.form);
          params.startTime = params.date[0];
          params.endTime = params.date[1];
          delete params.date;
          console.log(params);
          apiExportDate(params).then(() => {
            goFinanceExportPage().then(res => {
              if (res) {
                this.close();
              }
            }).catch(err => {
              console.error(err);
            });
          }).catch(err => {
            console.error(err);
          });
        }
      });
    },
    close() {
      this.$emit('change', false);
      this.$refs.form.resetFields();
    },
    // 业务类型切换
    changeType() {
      this.form.collectionCategory = '';
      this.form.cargoType = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
}
.dialog-footer ::v-deep .el-alert {
  padding: 0;
  background: transparent;
  text-align: start;
  line-height: 1;
}
</style>
